import { ArrowBack } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import defaultAxios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import Swal from "sweetalert2";
import axios from "../../services/axios";

interface IModalDeleteInvoicePenyewaProps {
    isOpenModalDeleteInvoicePenyewa: boolean;
    closeModalDeleteInvoicePenyewa: () => void;
    noInvoice: string;
    idInvoicePenyewa: string;
    refetch: () => void;
}

const ModalDeleteInvoicePenyewa = ({
    isOpenModalDeleteInvoicePenyewa,
    closeModalDeleteInvoicePenyewa,
    noInvoice,
    idInvoicePenyewa,
    refetch,
}: IModalDeleteInvoicePenyewaProps) => {
    const [isButtonLoading, setIsButtonLoading] = useState(false);

    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async () => {
            const res = await axios.delete(
                `/api/invoice-sewa/${idInvoicePenyewa}`,
            );
            return res.data;
        },
    });

    const handleDelete = () => {
        mutation.mutate(undefined, {
            onSuccess: () => {
                queryClient.invalidateQueries("list-invoice-penyewa");
                Swal.fire({
                    title: noInvoice + " berhasil dihapus!",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "success",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
                refetch();
                setIsButtonLoading(false);
            },
            onError: (error) => {
                handleErrorResponse(error);
            },
        });
        closeModalDeleteInvoicePenyewa();
    };

    const handleErrorResponse = useCallback(
        (error: any) => {
            if (defaultAxios.isAxiosError(error)) {
                const serverError = error as AxiosError<any>;
                if (serverError && serverError.response) {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `${serverError.response.data.message}`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalDeleteInvoicePenyewa();
                } else {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `Telah Terjadi Kesalahan`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalDeleteInvoicePenyewa();
                }
            }
        },
        [closeModalDeleteInvoicePenyewa],
    );

    return (
        <Dialog
            maxWidth="xs"
            fullWidth={true}
            open={isOpenModalDeleteInvoicePenyewa}
            onClose={() => {}}
            PaperProps={{
                sx: { borderRadius: 1 },
            }}
        >
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton
                        onClick={() => {
                            closeModalDeleteInvoicePenyewa();
                        }}
                    >
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" fontWeight="bold">
                        Hapus Penyewa
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {noInvoice} akan dihapus secara permanen. Yakin ingin
                    menghapus?
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                <LoadingButton
                    loading={isButtonLoading}
                    loadingPosition="center"
                    variant="outlined"
                    onClick={() => handleDelete()}
                    color="error"
                >
                    Hapus
                </LoadingButton>
                <Button
                    variant="contained"
                    onClick={() => {
                        closeModalDeleteInvoicePenyewa();
                    }}
                    color="error"
                >
                    Tidak
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDeleteInvoicePenyewa;
